export const Footer = () => {
    return (
        <footer className="header">
            <div className="menu">
                <div className="title">
                    <h2>WkSounds</h2>
                </div>
                <div className="list">
                    <div className="list-item">
                        <span>Dev: chupserso</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}